import React, { useState } from "react";

import { dataUndefined } from "../../../utils/dataProcessing";

import { useFormik } from "formik";
import moment from "moment";
import { FaFileExcel } from "react-icons/fa";
import { HiFilter } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import { BoxAnalyticCharDonut } from "../../../components/Analytic/BoxAnalyticCharDonut";
import { CreateAndDetailLayout } from "../../../components/CreateAndDetailLayout";
import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { Select } from "../../../components/Form/Select";
import { InfoCards } from "../../../components/InfoCards";
import Modal from "../../../components/ModalLib";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import { Pagination } from "../../../components/panel/table/Pagination";
import { TableContent } from "../../../components/panel/table/TableContent";
import { TableHeader } from "../../../components/panel/table/TableHeader";
import {
  OrderConfirm,
  OrderConfirmFilters,
  getOrderConfirmes,
  useOrderConfirmes,
  useOrderConfirmesAnalises,
  useOrderFilters,
} from "../../../hook/queries/useOrdersCofirmes";
import { useQueryParams } from "../../../hook/useQueryParams";
import * as sellerLocalStorage from "../../../service/localStorage/seller";
import { generateXlsx } from "../../../utils/generateXlsx";
import { ButtunSubmit, Form, ModalBody } from "../../create/styles";
import { columnsOrderConfirm } from "../../panel/PanelOrderConfirm";
import { BoxFilter, ContainerBoxAnalytic, ContainerList } from "../styles";

interface IProps {
  admin: boolean;
}

const OrderConfirmAnalytic: React.FC<IProps> = ({ admin }) => {
  const history = useHistory();
  const query = useQueryParams();
  const [page, setPage] = useState<number>(() => {
    const pageQuery = query.get("page");

    if (!isNaN(Number(pageQuery)) && Number(pageQuery) > 0)
      return Number(pageQuery);

    return 1;
  });
  const [sellerStorage] = useState(
    () =>
      sellerLocalStorage.getUser() as sellerLocalStorage.SellerProps | undefined
  );

  const [modalVisible, setModalVisible] = useState(false);
  const [filters, setFilters] = useState<OrderConfirmFilters>(
    {} as OrderConfirmFilters
  );
  const getOrderFilters = useOrderFilters({
    ...filters,
  });
  const { data, isLoading, isFetching } = useOrderConfirmes(page, filters);
  const getOrderConfirmesAnalises = useOrderConfirmesAnalises(filters);

  const formikFilter = useFormik({
    initialValues: {
      cod: undefined,
      codClient: undefined,
      cnpj: undefined,
      codSeller: undefined,
      brands: [],
      status: [],
      orderPeriod: undefined,
      orderPresetDate: undefined,
      orderSpecificDate: undefined,
      orderStartDate: undefined,
      orderEndDate: undefined,
      colection: undefined,
    },
    onSubmit: (data) => {
      handleFilter(data as any);
    },
  });

  function handleFilter(data: OrderConfirmFilters) {
    setFilters(data);
    setPage(1);
    setModalVisible(false);
  }

  function handleClearFilter() {
    setFilters({} as OrderConfirmFilters);
    formikFilter.handleReset({});
  }

  async function handleExport() {
    const getData = await getOrderConfirmes(1, filters, 99999);

    generateXlsx({
      data: getData.orderConfirmes.map((order) => ({
        CONFIRMADO:
          order.confirmed === undefined || order.confirmed === null
            ? "PENDENTE"
            : order.confirmed
            ? "SIM"
            : "NÃO",
        CÓDIGO: order.orderId,
        MARCA: order.order.brand?.name,
        "CÓD. REPRESENTANTE": order?.seller?.cod,
        REPRESENTANTE: order?.seller?.abbreviation,
        "TIPO REPRESENTANTE": order?.seller?.typeSeller,
        "CÓD. REPRESENTANTE PRINCIPAL": order?.seller?.sellerMain ?? "-",
        "CÓD. GNV": order?.seller?.cod_manager,
        "CÓD. GRV": order?.seller?.cod_supervisor ?? "-",
        CLIENTE: order.client?.company_name ?? "-",
        "DATA DO PEDIDO": order.order
          ? moment(order.order?.entryDate).format("DD/MM/YYYY")
          : "",
        "VALOR TOTAL": Number(order?.order?.totalInvoiceValue),
      })),
      filename: "confirmação de pedido",
    });
  }

  const isManagerOrSupervisor =
    !!sellerStorage?.is_manager || !!sellerStorage?.is_supervisor;

  return (
    <CreateAndDetailLayout>
      <PanelAndDetailAndCreateHeader
        title={"Análise da Confirmação de pedidos"}
        goBack
      />

      <InfoCards
        style={{
          margin: "0",
        }}
        cards={[
          {
            title: "VALOR TOTAL",
            value: getOrderConfirmesAnalises.data?.totalAmount
              ? getOrderConfirmesAnalises.data?.totalAmount.toLocaleString(
                  "pt-br",
                  {
                    style: "currency",
                    currency: "BRL",
                  }
                )
              : "-",
          },
          {
            title: "QUANTIDADE TOTAL",
            value: dataUndefined(getOrderConfirmesAnalises.data?.totalQuantity),
          },
        ]}
      />

      <ContainerBoxAnalytic>
        <BoxAnalyticCharDonut
          obs={<>*Análise feita através da quantidade</>}
          title="Situações"
          values={
            getOrderConfirmesAnalises?.data?.statuses?.map((item) => ({
              name: item.confirmed ? "CONFIRMADO" : "AGUARDANDO",
              length: item.totalQuantity,
              amount: item.totalAmount,
            })) ?? []
          }
        />
      </ContainerBoxAnalytic>

      <ContainerList>
        <TableHeader
          title={`PEDIDOS (${data?.totalCount ?? 0})`}
          isFetching={isFetching && !isLoading}
        >
          {(admin || isManagerOrSupervisor) && (
            <button style={{ background: "#2d792f" }} onClick={handleExport}>
              <FaFileExcel size={19} />
              <span>EXPORTAR</span>
            </button>
          )}
        </TableHeader>

        <TableContent<OrderConfirm>
          data={data?.orderConfirmes}
          columns={columnsOrderConfirm.filter((f) => f.viewList)}
          isLoading={isLoading}
          onClickRow={(e) =>
            history.push(
              `/${admin ? "admin/" : "representante/"}confirmacao-pedidos/${
                e.orderId
              }`
            )
          }
        />
        <Pagination
          totalCountOfRegisters={data?.totalCount ?? 0}
          currentPage={page}
          onPageChange={setPage}
        />
      </ContainerList>

      <Modal
        title="Filtros"
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        maxHeight={600}
      >
        <ModalBody>
          <Form onSubmit={formikFilter.handleSubmit}>
            <div
              style={{
                overflowY: "auto",
                height: 400,
                maxHeight: 400,
                padding: 10,
              }}
            >
              <Select
                label="COLEÇÃO"
                data={
                  getOrderFilters?.data?.colections?.map((colection) => ({
                    name: `${String(colection?.name)}`,
                    value: String(colection?.id),
                  })) ?? []
                }
                {...formikFilter.getFieldProps("colection")}
              />

              <GroupInput>
                <Input
                  label="CÓDIGO CLIENTE"
                  {...formikFilter.getFieldProps("codClient")}
                />
                <Input label="CNPJ" {...formikFilter.getFieldProps("cnpj")} />
              </GroupInput>

              <GroupInput>
                <Select
                  label="CÓD. VENDEDOR"
                  data={
                    getOrderFilters?.data?.sellers?.map((seller) => ({
                      name: `${String(seller?.id)} ${String(seller?.name)}`,
                      value: String(seller?.id),
                    })) ?? []
                  }
                  {...formikFilter.getFieldProps("codSeller")}
                />

                <Select
                  label="MARCA"
                  data={
                    getOrderFilters?.data?.brands?.map((brand) => ({
                      name: String(brand.name),
                      value: String(brand.id),
                    })) ?? []
                  }
                  {...formikFilter.getFieldProps("brand")}
                />

                <Select
                  label="CONFIRMAÇÃO"
                  data={[
                    { name: "CONFIRMADO", value: "CONFIRMADO" },
                    { name: "PENDENTE", value: "PENDENTE" },
                  ]}
                  {...formikFilter.getFieldProps("confirmed")}
                />
              </GroupInput>

              <Select
                label="DATA DO PEDIDO"
                data={[
                  { name: "Específica", value: 2 },
                  { name: "Intervalo", value: 3 },
                ]}
                {...formikFilter.getFieldProps("orderPeriod")}
              />

              {Number(formikFilter.values.orderPeriod) === 2 && (
                <Input
                  type="date"
                  label="DATA DO PEDIDO"
                  {...formikFilter.getFieldProps("orderSpecificDate")}
                  error={
                    formikFilter.touched.orderSpecificDate &&
                    formikFilter.errors.orderSpecificDate
                      ? formikFilter.errors.orderSpecificDate
                      : undefined
                  }
                />
              )}

              {Number(formikFilter.values.orderPeriod) === 3 && (
                <GroupInput>
                  <Input
                    type="date"
                    label="DATA INICIAL"
                    {...formikFilter.getFieldProps("orderStartDate")}
                    error={
                      formikFilter.touched.orderStartDate &&
                      formikFilter.errors.orderStartDate
                        ? formikFilter.errors.orderStartDate
                        : undefined
                    }
                  />
                  <Input
                    type="date"
                    label="DATA FINAL"
                    {...formikFilter.getFieldProps("orderEndDate")}
                    error={
                      formikFilter.touched.orderEndDate &&
                      formikFilter.errors.orderEndDate
                        ? formikFilter.errors.orderEndDate
                        : undefined
                    }
                  />
                </GroupInput>
              )}
            </div>

            <GroupInput>
              <div className="field" style={{ marginBottom: 0 }}>
                <ButtunSubmit
                  onClick={handleClearFilter}
                  style={{
                    background: "#fff",
                    color: "#d21e26",
                  }}
                  type="button"
                >
                  LIMPAR FILTRO
                </ButtunSubmit>
              </div>

              <div className="field" style={{ marginBottom: 0 }}>
                <ButtunSubmit type="submit">BUSCAR</ButtunSubmit>
              </div>
            </GroupInput>
          </Form>
        </ModalBody>
      </Modal>

      <BoxFilter>
        <div className="fixedButton">
          <button onClick={() => setModalVisible(!modalVisible)}>
            <HiFilter color="#FFF" size={26} />
          </button>
        </div>
      </BoxFilter>
    </CreateAndDetailLayout>
  );
};

export { OrderConfirmAnalytic };
